import React, { useEffect, useState, useMemo } from "react";
import Layout from "../../Layout";
import { memberData, sortsDatas } from "../../components/Datas";
import { Link, useNavigate } from "react-router-dom";
import { BiChevronDown, BiPlus, BiTime } from "react-icons/bi";
import { BsCalendarMonth } from "react-icons/bs";
import ReactLoading from "react-loading";
import { MdFilterList, MdOutlineCalendarMonth } from "react-icons/md";
import { toast } from "react-hot-toast";
import { Button, FromToDate, Select } from "../../components/Form";
import { PatientTable } from "../../components/Tables";
import NotFound from "../NotFound";
import WithoutData from "../WithoutData";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllPatients,
  getPatientError,
  getPatientStatus,
  getPatients,
  setPatient,
  updatePatient,
} from "../../redux/features/patientSlice";
import Loading from "../Loading";
import { HiOutlineCheckCircle, HiOutlineXCircle } from "react-icons/hi";
import { confirmAlert } from "react-confirm-alert";

function Patients() {
  const [filtro, setFiltro] = useState("");
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [startDate, endDate] = dateRange;
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const patients = useSelector(getAllPatients);
  const patientStatus = useSelector(getPatientStatus);
  const patientError = useSelector(getPatientError);

  useEffect(() => {
    dispatch(getPatients());
  }, [dispatch]);

  // Filtro tipo LIKE optimizado con useMemo
  const filteredData = useMemo(() => {
    if (!filtro) return patients?.data ?? [];

    const searchTerm = filtro.toLowerCase().trim();
    const searchTerms = searchTerm.split(/\s+/); // Divide por espacios

    return (
      patients?.data?.filter((item) => {
        // Check if persona exists and has the required properties
        if (!item?.persona) return false;

        const nombre = item.persona.nombre?.toLowerCase() || "";
        const apellidos = item.persona.apellidos?.toLowerCase() || "";
        const nombreCompleto = `${nombre} ${apellidos}`;
        const ci = item.persona.ci?.toLowerCase() || "";

        // Coincidencia exacta
        if (nombreCompleto.includes(searchTerm) || ci.includes(searchTerm)) {
          return true;
        }

        // Coincidencia con todos los términos
        return searchTerms.every(
          (term) =>
            nombre.includes(term) ||
            apellidos.includes(term) ||
            ci.includes(term)
        );
      }) ?? []
    );
  }, [filtro, patients?.data]);

  if (patientStatus === "loading") return <Loading />;
  if (patientStatus === "failed") {
    toast.error(`${patientError}`);
  }

  const handleFilter = (e) => {
    setFiltro(e.target.value);
  };

  const previewPayment = (id) => {
    navigate(`/patients/preview/${id}`);
  };

  const editPatient = (id) => {
    navigate(`/patients/edit/${id}`);
  };

  const bajaPatient = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui flex flex-col text-center gap-5 border border-red-500 rounded-lg p-5 bg-white">
            <h1 className=" font-bold text-lg">
              ¿Está seguro de dar de baja al paciente?
            </h1>
            <p className="font-light">
              Se perderán todos los datos relacionados al paciente.
            </p>
            <div className="flex flex-row gap-5 lg:gap-10">
              <Button label={"No"} Icon={HiOutlineXCircle} onClick={onClose} />
              <Button
                label={"Sí"}
                Icon={HiOutlineCheckCircle}
                onClick={async () => {
                  const newData = await dispatch(
                    updatePatient({ id, estado: false })
                  );

                  if (newData.error) {
                    toast.error(
                      `Ocurrió un error al dar de Baja al Paciente: ${newData.error}`,
                      { duration: 5000 }
                    );
                  } else {
                    toast.success("Paciente dado de Baja", { duration: 5000 });
                    navigate(0);
                  }
                  onClose();
                }}
              />
            </div>
          </div>
        );
      },
    });
  };

  return (
    <Layout>
      {/* Botón para agregar nuevo paciente */}
      <Link
        to="/patients/create"
        className="w-16 animate-bounce h-16 border border-border z-40 bg-subMain text-white rounded-full flex-colo fixed bottom-8 right-12 button-fb"
      >
        <BiPlus className="text-2xl" />
      </Link>

      <h1 className="text-xl font-semibold">Pacientes</h1>

      <div
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="10"
        data-aos-offset="200"
        className="bg-white my-8 rounded-xl border-[1px] border-border p-5"
      >
        <div className="grid lg:grid-cols-1 grid-cols-1 xs:grid-cols-1 md:grid-cols-1 gap-2">
          <input
            type="text"
            placeholder="Filtrar por Nombre, Apellido o CI"
            value={filtro}
            onChange={handleFilter}
            className="h-14 text-sm text-main rounded-md bg-dry border border-border px-4"
          />
        </div>
        <div className="mt-8 w-full overflow-auto">
          {filteredData.length > 0 ? (
            <PatientTable
              data={filteredData}
              functions={{
                preview: previewPayment,
                edit: editPatient,
                delete: bajaPatient,
              }}
              used={false}
            />
          ) : (
            <WithoutData text="Crear Paciente" url="/patients/create" />
          )}
        </div>
      </div>
    </Layout>
  );
}

export default Patients;
